import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import Services from "../sections/Services";
import CTASection from "../sections/CTASection";
import { IMAGES } from "../data/content";

export default function ServicesPage() {
  useSEO({
    title: "Services",
    description:
      "Film production, music, live events, VR cinema, original content and global distribution — the full creative spectrum of Ideal Entertainment.",
  });
  return (
    <>
      <PageHero
        overline="Our Services"
        title="From concept to worldwide premiere"
        subtitle="A full-spectrum entertainment studio — films, music, live events and immersive experiences."
        image="https://images.unsplash.com/photo-1518930259200-3e5b29f42096?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <Services detailed />
      <CTASection />
    </>
  );
}
